import { useEffect, useState } from 'react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import api from '../services/api';

export default function LeaveDashboard() {
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    api.get('/lms/dashboard').then((res) => setData(res.data));
  }, []);

  if (!data) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Leave Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="font-semibold text-gray-700 mb-1">Pending Year-End</h3>
          <p className="text-3xl font-bold text-amber-600">{data.pendingYearEndCount}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="font-semibold text-gray-700 mb-1">Pending My Approval</h3>
          <p className="text-3xl font-bold text-blue-600">{data.pendingApprovalCount}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="font-semibold text-gray-700 mb-2">Leaves This Month (Trend)</h3>
          {data.leavesThisMonthTrend.length === 0 ? (
            <p className="text-sm text-gray-400 py-8 text-center">No leave applications yet</p>
          ) : (
            <ResponsiveContainer width="100%" height={220}>
              <LineChart data={data.leavesThisMonthTrend}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Line type="monotone" dataKey="count" name="Applications" stroke="#2563eb" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          )}
        </div>
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="font-semibold text-gray-700 mb-2">Employees by Leave Type (This Year)</h3>
          {data.employeesByLeaveType.length === 0 ? (
            <p className="text-sm text-gray-400 py-8 text-center">No data</p>
          ) : (
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={data.employeesByLeaveType} layout="vertical" margin={{ left: 10 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" allowDecimals={false} />
                <YAxis type="category" dataKey="leave_type_name" width={110} />
                <Tooltip />
                <Bar dataKey="employee_count" name="Employees" fill="#16a34a" />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </div>
  );
}
